import { Basics } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';

// Botó fix (#ScrollIndicator, a default.njk). Visibilitat via CSS (--visible),
// el clic fa un scroll d'un fold exacte des de la posició actual.
export default class ScrollIndicator {
  static CLASS_VISIBLE = '--visible';
  // Fins on es veu, en folds. Per defecte el 20% del primer fold;
  // cada pàgina en pot fer override amb `scrollIndicatorRatio` (veure Default/Home).
  static HIDE_RATIO = .2;

  static _el = null;
  static _isEnabled = false;
  static _call = () => ScrollIndicator.goto();

  static show() {
    if (!this._el) this._el = GetBy.id('ScrollIndicator');
    if (!this._el || this._isEnabled) return;

    this._el.addEventListener(Basics.clickEvent, this._call);
    this._el.classList.add(this.CLASS_VISIBLE);
    this._isEnabled = true;
  }

  static hide() {
    if (!this._el || !this._isEnabled) return;

    this._el.removeEventListener(Basics.clickEvent, this._call);
    this._el.classList.remove(this.CLASS_VISIBLE);
    this._isEnabled = false;
  }

  // Cridat des del loop de la pàgina: visible mentre no hem passat el 20% del fold.
  // Scroll.limit === 0 → pàgines __noScroll (Products i NoScroll), que es mouen amb un
  // InfiniteScroll cíclic: allà no hi ha ni "dalt de tot" ni un fold on anar, i queden fora.
  static check(ratio = this.HIDE_RATIO) {
    const isScrollable = Scroll.limit > 0;
    const isTop = Scroll.y < Metrics.HEIGHT * ratio;

    (isTop && isScrollable) ? this.show() : this.hide();
  }

  // Un fold exacte: alçada de viewport des d'on estem ara.
  static goto() {
    Scroll.goto(Scroll.y + Metrics.HEIGHT);
  }
}
